export default "__VITE_ASSET__DOAmJi9H__"